import { useState, useEffect } from 'react';

export const useA11yState = (initialValue = false) => {
  const [isVideoAccessible, setIsVideoAccessible] = useState(initialValue);

  const setVideoAccessibility = (enabled?: boolean) => {
    const newState = enabled !== undefined ? enabled : !isVideoAccessible;
    localStorage.setItem('accessibleVideo', newState.toString());
    setIsVideoAccessible(newState);
    window.dispatchEvent(
      new CustomEvent('a11yStateChange', { detail: newState }),
    );
  };

  useEffect(() => {
    // Migrate from old UsableNet localStorage key to new key (one-time migration)
    const migrateFromUsableNet = () => {
      const oldValue = localStorage.getItem('UsableNetAssistive');
      const newValue = localStorage.getItem('accessibleVideo');

      // Only migrate if old value exists and new value doesn't exist yet
      if (oldValue !== null && newValue === null) {
        localStorage.setItem('accessibleVideo', oldValue);
        localStorage.removeItem('UsableNetAssistive');
      }
    };

    const checkA11y = () => {
      const storedA11y = localStorage.getItem('accessibleVideo');
      const newState = storedA11y === 'true';
      setIsVideoAccessible(newState);
    };

    // Run migration first, then check current state
    migrateFromUsableNet();
    checkA11y();

    const handleA11yChange = (event: Event) => {
      const customEvent = event as CustomEvent;
      if (customEvent.detail !== undefined) {
        setIsVideoAccessible(customEvent.detail);
      } else {
        checkA11y();
      }
    };

    window.addEventListener('a11yStateChange', handleA11yChange);
    window.addEventListener('storage', checkA11y);

    return () => {
      window.removeEventListener('a11yStateChange', handleA11yChange);
      window.removeEventListener('storage', checkA11y);
    };
  }, []);

  return { isVideoAccessible, setVideoAccessibility };
};
